import axios from './axiosConfig'

export type DashboardHomeParams = {
 from_date?: string
 to_date?: string
 branch_id?: string
 include_comparison?: boolean
}

export const dashboardAPI = {
 getStatistics: async () => {
 const response = await axios.get('/dashboard/statistics')
 return response.data
 },

 getBranchComparison: async () => {
 const response = await axios.get('/dashboard/branch-comparison')
 return response.data
 },

 getTreasurySummary: async () => {
 const response = await axios.get('/dashboard/treasury-summary')
 return response.data
 },

 getGlobalAnalytics: async () => {
 const response = await axios.get('/dashboard/global-analytics')
 return response.data
 },

 getBranchOperational: async () => {
 const response = await axios.get('/dashboard/branch-operational')
 return response.data
 },

 getHome: async (params: DashboardHomeParams) => {
  const response = await axios.get('/dashboard/home', { params })
  return response.data
 },
}
